export function capitalizeFirst(input) {
  if (input === null || input === undefined) return '';
  const str = String(input);
  if (!str) return '';
  const firstAlphaIndex = str.search(/[A-Za-z]/);
  if (firstAlphaIndex === -1) return str;
  const firstChar = str.charAt(firstAlphaIndex);
  return str.slice(0, firstAlphaIndex) + firstChar.toUpperCase() + str.slice(firstAlphaIndex + 1);
}

export function capitalizeFirstOnChange(value) {
  if (value === null || value === undefined) return '';
  const str = String(value);
  if (str.length === 0) return '';
  const firstAlphaIndex = str.search(/[A-Za-z]/);
  if (firstAlphaIndex === -1) return str;
  return capitalizeFirst(str);
}
